/**
 * Small className concatenator — avoids pulling in `clsx`/`tailwind-merge`
 * at this stage. Filters out falsy values.
 *
 *   cn('px-4', isOpen && 'bg-blue-50', props.className)
 */
export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}
